import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}

  setLocalStorage(name: string, data: any) {
    try {
      localStorage.setItem(name, JSON.stringify(data));
    } catch (error: any) {
      if (error?.name.indexOf('QUOTA') !== -1) {
        alert('Local browser storage has been exceeded. Re-Enter data.');
      }
    }
  }

  getLocalStorage(name: string): any {
    if (!localStorage[name] || localStorage[name] === 'undefined') {
      return null;
    } else {
      return JSON.parse(localStorage.getItem(name) || '{}');
    }
  }

  clear() {
    localStorage.clear();
  }

  remove(name: string) {
    localStorage.removeItem(name);
    if (!localStorage[name]) {
      return '';
    } else {
      return localStorage.removeItem(name);
    }
  }
}
